import { useState, type FormEvent } from 'react'

type FormStatus = 'idle' | 'submitting' | 'success'

export function ReservationForm() {
  const [status, setStatus] = useState<FormStatus>('idle')

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!event.currentTarget.reportValidity()) return
    setStatus('submitting')
    window.setTimeout(() => setStatus('success'), 550)
  }

  return (
    <form className="reservation-form" onSubmit={submit} aria-describedby="reservation-note">
      <div className="form-grid">
        <label>
          <span>Date</span>
          <input type="date" name="date" required />
        </label>
        <label>
          <span>Time</span>
          <select name="time" required defaultValue="">
            <option value="" disabled>
              Select a time
            </option>
            <option>5:00 pm</option>
            <option>5:30 pm</option>
            <option>6:00 pm</option>
            <option>6:30 pm</option>
            <option>7:00 pm</option>
            <option>7:30 pm</option>
            <option>8:00 pm</option>
            <option>8:30 pm</option>
            <option>9:00 pm</option>
          </select>
        </label>
        <label>
          <span>Party size</span>
          <select name="partySize" required defaultValue="2">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((size) => (
              <option key={size} value={size}>
                {size} {size === 1 ? 'guest' : 'guests'}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span>Name</span>
          <input type="text" name="name" autoComplete="name" required />
        </label>
        <label>
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required />
        </label>
        <label>
          <span>Phone</span>
          <input type="tel" name="phone" autoComplete="tel" required />
        </label>
      </div>
      <label className="form-note-field">
        <span>Occasion or requests <small>Optional</small></span>
        <textarea name="notes" rows={3} />
      </label>
      <div className="form-submit">
        <button className="button button--light" type="submit" disabled={status === 'submitting'}>
          {status === 'submitting' ? 'Checking the table…' : 'Request a table'}
        </button>
        <p id="reservation-note">
          This demonstration does not transmit personal information. Connect your reservation provider in the site configuration before launch.
        </p>
      </div>
      <p className="form-status" role="status" aria-live="polite">
        {status === 'success'
          ? 'Your request is ready. A live reservation service can be connected here before launch.'
          : ''}
      </p>
    </form>
  )
}

